import authHeader from "../helpers/authHeader";
import history from "../helpers/history";
import userService from "./userService";

const getAppointmentsByMonth = async (date) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(date),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/GetAppointmentsByMonth`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const getLitigant = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(id),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetUserWithId`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
};

const getAttorney = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(id),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetAttorneyWithId`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
};

const getLitigantByEmail = async (id) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(id),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/GetUserWithEmail`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      return user;
    });
};

const getAppointmentsByMonthAtt = async (date) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(date),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/GetAppointmentsByMonthAtt`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const getAppointmentsForRequest = async (date) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/GetAppointmentsForRequest`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const setAppointmentLitigant = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/SetAppointmentLitigant`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const sendAttorneyQuestionnaire = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/SendAttorneyQuestionnaire`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const sendLitigantReminder = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/SendLitigantReminder`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const userRescheduleAppointment = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/UserRescheduleAppointment`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      history.push("/user");
      return;
    });
};

const cancelAppointmentUser = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/CancelAppointmentUser`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      history.push("/user");
      return;
    });
};

const setAppointmentAttorney = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/SetAppointmentAttorney`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const deleteAppointment = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/DeleteAppointment`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const reAddAppointment = async (apptId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(apptId),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/ReAddAppointment`,
    requestOptions
  )
    .then(handleResponse)
    .then(() => {
      return;
    });
};

const createAppointments = async (date) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(date),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/CreateAppointments`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const createCustomAppointments = async (dates) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(dates),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/CreateCustomAppointments`,
    requestOptions
  )
    .then(handleResponse)
    .then((payload) => {
      return payload;
    });
};

const getAttorneyAppointments = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/GetAttorneyAppointments`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const attorneyCancelAppointment = async (appt) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(appt),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/CancelAppointmentAttorney`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const attorneyCompleteAppointment = async (appt) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(appt),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/CompleteAppointmentAttorney`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const userRequestAppointment = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/UserRequestAppointment`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const attorneyAssignToMe = async (appt) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(appt),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/Appointment/AttorneyAssignToMe`,
    requestOptions
  )
    .then(handleResponse)
    .then((dates) => {
      return dates;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      console.log(response);
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const appointmentService = {
  getAppointmentsByMonth,
  getAppointmentsByMonthAtt,
  setAppointmentAttorney,
  setAppointmentLitigant,
  deleteAppointment,
  createAppointments,
  reAddAppointment,
  getAttorneyAppointments,
  attorneyCancelAppointment,
  attorneyCompleteAppointment,
  getLitigant,
  attorneyAssignToMe,
  userRequestAppointment,
  getLitigantByEmail,
  getAppointmentsForRequest,
  getAttorney,
  userRescheduleAppointment,
  cancelAppointmentUser,
  createCustomAppointments,
  sendAttorneyQuestionnaire,
  sendLitigantReminder,
};

export default appointmentService;
